<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      :items-per-page="50"
      item-key="id"
      class="font-resp-tabela table-full-screen"
      :height="ALTURA_TABELA"
    >
      <template #top>
        <div class="d-flex align-center pl-2 pt-3 pb-2">
          <div class="d-flex ml-n2">
            <v-icon :size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
            <p class="ma-0 subtitle-1 font-weight-medium">Filiais de separação</p>
          </div>

          <v-spacer/>

          <div class="w-450 mt-n1">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa"
              single-line
              hide-details
              clearable
              dense
              class="pr-5"
            />
          </div>

          <v-btn color="primary" dark small @click="dialog_ativo = true">
            <v-icon left>mdi-plus</v-icon>
            <span>Novo</span>
          </v-btn>

        </div>
      </template>

      <template #item.filial_destino="{item}">
        {{ item.filial_destino }}

        <template v-if="item.descricao_filial">
          - {{ item.descricao_filial }}
        </template>
      </template>

      <template #item.filial_origem="{item}">
        <v-chip
          v-for="item in item.filial_origem"
          :key="item"
          class="mr-1"
        >
          {{ item }}
        </v-chip>
      </template>

      <template #item.action="{ item }">
        <div class="d-flex align-center">
          <v-btn icon @click="editarItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon class="ml-n1" @click="excluir(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <SysDialog
      v-model="dialog_ativo"
      persistent
      titulo="Filial de destino X Filiais de origem"
      @click:hidden-dialog="fecharDialog"
      @click:primary="salvar"
    >
      <SysGrupoAutocomplete
        v-model="editedItem.id_grupo"
        :items="gruposDistinct"
        label="Selecione o Grupo de Separação*"
        item-text="descricao"
        item-value="id"
        outlined
        :ocultar_grupos_todos="false"
        apenas_grupos_drp
        :error-messages="grupoErrors"
        @input="$v.editedItem.id_grupo.$touch()"
        @change="editedItem.filial_destino = ''"
        :disabled="indexItemEdicao > -1"
      />

      <SysFilialGrupoAutocomplete
        v-model="editedItem.filial_destino"
        :items="filiaisGrupo"
        label="Selecione a Filial de destino*"
        item-text="filial"
        item-value="filial"
        :id-grupo="editedItem.id_grupo"
        outlined
        :error-messages="filialDestinoErrors"
        @input="$v.editedItem.filial_destino.$touch()"
        @change="selecionarGrupo()"
        :disabled="indexItemEdicao > -1"
      />

      <SysFilialGrupoAutocomplete
        v-model="editedItem.filial_origem"
        :items="filiaisGrupoOrigem"
        label="Selecione as Filiais de origem*"
        item-text="filial"
        item-value="filial"
        :id-grupo="editedItem.id_grupo"
        outlined
        multiple
        class="mb-n4"
        :error-messages="filialOrigemErrors"
        @input="$v.editedItem.filial_origem.$touch()"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {required} from "vuelidate/lib/validators";
import DrpAPI from "@/api/drp";
import {logout} from "@/helpers";

export default {
  name: "MapaDeSeparacao",
  components: { SysFilialGrupoAutocomplete, SysGrupoAutocomplete, SysDialog },
  data: () => ({
    dialog_ativo: false,
    indexItemEdicao: -1,
    search: '',
    editedItem: {
      id_grupo: '',
      filial_origem: [],
      filial_destino: '',
    },
    headers: [
      { text: "Grupo", value: "descricao_grupo" },
      { text: "Filial Destino", value: "filial_destino" },
      { text: "Filiais de Origem", value: "filial_origem" },
      {
        text: "Ações",
        value: "action",
        sortable: false,
        width: "50px",
        align: "right",
      },
    ],
    desserts: [],
    listaGrupoFiliais: []
  }),
  validations: {
    editedItem: {
      id_grupo: { required },
      filial_destino: { required },
      filial_origem: { required }
    }
  },
  computed: {
    grupoErrors() {
      const errors = [];

      if (!this.$v.editedItem.id_grupo.$dirty) return errors;
      !this.$v.editedItem.id_grupo.required && errors.push("Campo Obrigatório.");

      return errors;
    },
    filialDestinoErrors() {
      const errors = [];

      if (!this.$v.editedItem.filial_destino.$dirty) return errors;
      !this.$v.editedItem.filial_destino.required && errors.push("Campo Obrigatório.");

      return errors;
    },
    filialOrigemErrors() {
      const errors = [];

      if (!this.$v.editedItem.filial_origem.$dirty) return errors;
      !this.$v.editedItem.filial_origem.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    gruposDistinct() {
      let grupos = []

      this.listaGrupoFiliais.forEach(item => {
        const grupoItem = {
          id: item.id_grupo,
          descricao: item.descricao,
        }

        if (!grupos.includes(grupoItem)) {
          grupos.push(grupoItem)
        }
      })

      return grupos
    },
    filiaisGrupo() {
      if (this.editedItem.id_grupo > 0) {
        return this.listaGrupoFiliais.filter(item => item.id_grupo == this.editedItem.id_grupo)
      } else {
        return this.listaGrupoFiliais
      }
    },
    filiaisGrupoOrigem() {
      const { filial_destino } = this.editedItem

      return this.filiaisGrupo.filter(item => item.filial != filial_destino)
    },
    ALTURA_TABELA() {
      const altura_config = '240px';
      const altura_parametrizacao = '170px';

      return this.$route.meta.layout == 'parametrizacao' ? `calc(100vh - ${altura_parametrizacao})` : `calc(100vh - ${altura_config})`;
    }
  },
  created() {
    this.listarFiliaisSeparacao()
  },
  methods: {
    selecionarGrupo() {
      this.editedItem.filial_origem = []

      if (!this.editedItem.id_grupo) {
        const { filial_destino } = this.editedItem
        const grupoFilial = this.listaGrupoFiliais.filter(item => item.filial == filial_destino)

        this.editedItem.id_grupo = grupoFilial[0] ? grupoFilial[0].id_grupo : ''
      }
    },
    listarFiliaisSeparacao() {
      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getFiliaisSeparacao(headers)
          .then((response) => {
            const { token, filiaisSeparacao, filiais } = response.data

            localStorage.setItem("token", token)
            this.desserts = filiaisSeparacao
            this.listaGrupoFiliais = filiais
          })
          .catch(logout)
      )
    },
    fecharDialog() {
      this.$v.$reset();
      this.indexItemEdicao = -1;
      this.dialog_ativo = false;

      this.editedItem = {
        id_grupo: '',
        filial_origem: [],
        filial_destino: '',
      };
    },
    editarItem(item) {
      this.indexItemEdicao = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_ativo = true;
    },
    excluir(item) {
      const headers = this.Helpers.iniciarRequisicao()
      const params = { filial_destino: item.filial_destino }

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.deleteFiliaisSeparacao(headers, params)
          .then((response) => {
            const { token } = response.data

            localStorage.setItem("token", token)
            this.listarFiliaisSeparacao()
          })
          .catch(logout)
      )
    },
    salvar() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao()
        const params = this.editedItem

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.setFiliaisSeparacao(headers, params)
            .then((response) => {
              const { token } = response.data

              localStorage.setItem("token", token)
              this.listarFiliaisSeparacao()
              this.fecharDialog()
            })
            .catch(logout)
        )
      }
    }
  }
}
</script>
